import { z } from "zod";
import { BaseOutputSchema } from "./BaseOutput";

export const DeleteUploadedFileOutputSchema = BaseOutputSchema.extend({
    isDeleted: z.boolean(),
    deletedFileId: z.string().nullish(),
});

export type DeleteUploadedFileOutput = z.infer<typeof DeleteUploadedFileOutputSchema>;